import { api } from 'app/utils/api/helpers'

export const updateTenantSettings = (propertyGUID, contactGUID, payload) => {
  return api.put(
    `/sm/properties/${propertyGUID}/tenants/${contactGUID}/settings`,
    payload,
  )
}

export const sendWithdrawNotice = (offerID, payload) => {
  return api.post(`/sm/offers/${offerID}/withdraw-notice`, payload)
}

export const getLatestWithdrawNotice = (offerID) => {
  return api.get(`/sm/offers/${offerID}/withdraw-notice`)
}
